import { useCallback, useEffect, useState } from "react";
import { fetchCategoryList } from "../api/category";

export const useCategoryMap = (enabled = true) => {
  const [categoryMap, setCategoryMap] = useState<Map<string, string>>(new Map());
  const [loading, setLoading] = useState(enabled);

  useEffect(() => {
    if (!enabled) {
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);

    fetchCategoryList()
      .then((items) => {
        if (cancelled) return;
        const map = new Map<string, string>();
        items.forEach((category) => {
          if (!category.id) return;
          map.set(category.id, category.name || category.description || category.id);
        });
        setCategoryMap(map);
      })
      .catch(() => {
        if (!cancelled) setCategoryMap(new Map());
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [enabled]);

  const resolveCategoryName = useCallback(
    (categoryId: string) => categoryMap.get(categoryId) ?? "—",
    [categoryMap]
  );

  return { categoryMap, resolveCategoryName, loading };
};
